import * as React from 'react'

import type { Collection } from 'modules/core/lib/mobx-rest'

import type { TaskTypes } from 'modules/bookkeepers/store/collections/taskTypes'
import type TaskType from 'modules/bookkeepers/store/models/TaskType'

type TaskTypeContextValue = TaskTypes | null | undefined

const TaskTypeContext = React.createContext<TaskTypeContextValue>(null)

interface TaskTypeProviderProps {
  collection: Collection<TaskType>
}

export const TaskTypesProvider = ({
  collection,
  children,
}: React.PropsWithChildren<TaskTypeProviderProps>) => (
  <TaskTypeContext.Provider value={collection as TaskTypes}>{children}</TaskTypeContext.Provider>
)

export const useTaskTypes = (): TaskTypes => {
  const taskTypes = React.useContext(TaskTypeContext)

  if (!taskTypes) {
    throw new Error('useTaskTypes must be used within a TaskTypesProvider')
  }

  return taskTypes
}
